import {
    Button,
    ButtonBase,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    List,
    ListItemText,
    Menu,
    MenuItem,
    Paper,
    TextField,
    Typography
} from "@mui/material";
import {makeStyles} from "@mui/styles";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import ImageZoom from "react-medium-image-zoom";
import {v4 as uuidv4} from 'uuid';
import Cookies from 'universal-cookie';
import {formatImageUrl} from "../utils/utils";
import {useAuth} from "../utils/useAuth";
import React, {useRef} from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: '95px',
        marginLeft: '25px',
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        display: 'grid',
        margin: '15px',
        width: '96%',
        height: '-webkit-available'
    },
    image: {
        width: '120px',
        height: '-webkit-fill-available',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '5px',
        maxHeight: '76px',
        marginTop: '10px',
        minWidth: '80px',
        transform: 'scale(0.9)'
    }
}));

export default function WishlistDetail(props) {
    const classes = useStyles();
    const inputEl = useRef(null);
    const {getAccessToken} = useAuth();

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openFormDialog, setOpenFormDialog] = React.useState(false);
    const [openEditDialog, setOpenEditDialog] = React.useState(false);
    const [input, setInput] = React.useState("");
    const [productNote, setProductNote] = React.useState("");
    const [selectedProduct, setSelectedProduct] = React.useState("");
    const [items, setItems] = React.useState([]);
    const [products, setProducts] = React.useState([]);
    const [searching, setSearching] = React.useState(false);

    const [state, setState] = React.useState({
        openSuccess: false,
        openError: false,
        vertical: 'top',
        horizontal: 'right',
        successMessage: '',
        errorMessage: ''
    });

    const {vertical, horizontal, openSuccess, successMessage, openError, errorMessage} = state;

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    });

    const back = () => props.setWishlistDetail(false);

    const getWishlistDetails = async () => {
        try {
            props.setLoading(true);
            const accessToken = await getAccessToken();
            if (!accessToken) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get("hashCode") || "";

            const headers = new Headers({Authorization: accessToken + hashCode});

            const res = await fetch(
                `${process.env.REACT_APP_API_ENDPOINT}wishlist/products?id=${props.selectedWishlist.id}`,
                {method: "GET", headers}
            );

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();

            setProducts(data);
            props.setLoading(false);
        } catch (err) {
            console.error("getWishlistDetails error:", err);
            props.setLoading(false);
        }
    };

    const addProduct = async (smcInput) => {
        try {
            setSearching(true);
            const accessToken = await getAccessToken();
            if (!accessToken) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get("hashCode") || "";

            const generatedId = uuidv4();
            const linkString = smcInput.slice(0, 6) + "-" + smcInput.slice(6, 11) + "-" + smcInput.slice(11, 15);

            const newItem = {
                id: generatedId,
                wishlistID: props.selectedWishlist.id,
                smc: smcInput,
                position: "",
                imageLink: 'http://getimage.tech.gucci/getimage/?Cod=' + linkString,
                timestamp: Math.floor(Date.now() / 1000).toString(),
                note: ''
            };

            const headers = new Headers({
                Authorization: accessToken + hashCode,
                "Content-Type": "application/json"
            });

            const res = await fetch(
                `${process.env.REACT_APP_API_ENDPOINT}wishlist/products`,
                {method: "POST", headers, body: JSON.stringify(newItem)}
            );

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            await res.json();

            setItems([...items, newItem]);
            setProducts([...products, newItem]);
            setSearching(false);
            setState({openSuccess: true, openError: false, successMessage: "Product added successfully!"});
        } catch (err) {
            console.error("addProduct error:", err);
            props.setLoading(false);
            setSearching(false);
            setState({openError: true, openSuccess: false, errorMessage: "Something went wrong."});
        }
    };

    const removeProduct = async (product) => {
        try {
            setAnchorEl(null);
            props.setLoading(true);

            const accessToken = await getAccessToken();
            if (!accessToken) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get("hashCode") || "";

            const headers = new Headers({
                Authorization: accessToken + hashCode,
                "Content-Type": "application/json"
            });

            const res = await fetch(
                `${process.env.REACT_APP_API_ENDPOINT}wishlist/products`,
                {method: "DELETE", headers, body: JSON.stringify({id: product.id})}
            );

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            await res.json();

            await getWishlistDetails();
            setState({openSuccess: true, openError: false, successMessage: "Product deleted successfully!"});
        } catch (err) {
            console.error("removeProduct error:", err);
            props.setLoading(false);
            setState({openError: true, openSuccess: false, errorMessage: "Something went wrong."});
        }
    };

    const editProductNote = async () => {
        try {
            props.setLoading(true);

            const accessToken = await getAccessToken();
            if (!accessToken) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get("hashCode") || "";

            const headers = new Headers({
                Authorization: accessToken + hashCode,
                "Content-Type": "application/json"
            });

            const updatedItem = {
                id: selectedProduct.id,
                wishlistID: selectedProduct.wishlistID,
                smc: selectedProduct.smc,
                position: selectedProduct.position,
                imageLink: selectedProduct.imageLink,
                timestamp: selectedProduct.timestamp,
                note: productNote
            };

            const res = await fetch(
                `${process.env.REACT_APP_API_ENDPOINT}wishlist/products`,
                {method: "POST", headers, body: JSON.stringify(updatedItem)}
            );

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            await res.json();

            await getWishlistDetails();
            handleOpenEditDialog(false, []);
        } catch (err) {
            console.error("editProductNote error:", err);
            props.setLoading(false);
            handleOpenEditDialog(false, []);
        }
    };

    const downloadPdf = async () => {
        try {
            props.setLoading(true);

            const accessToken = await getAccessToken();
            if (!accessToken) throw new Error("Not authenticated");

            const cookies = new Cookies();
            const hashCode = cookies.get("hashCode") || "";

            const headers = new Headers({
                Authorization: accessToken + hashCode,
                "Content-Type": "application/json"
            });

            const body = JSON.stringify({
                id: props.selectedWishlist.id,
                assistat: props.selectedWishlist.client
            });

            const res = await fetch(
                process.env.REACT_APP_PDF_ENDPOINT + "wishlistpdf",
                {method: "POST", headers, body}
            );

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const result = await res.json();

            const link = document.createElement("a");
            link.href = result.path;
            link.click();

            props.setLoading(false);
        } catch (err) {
            console.error("downloadPdf error:", err);
            props.setLoading(false);
        }
    };

    const handleOpenFormDialog = (bool) => setOpenFormDialog(bool);
    const handleOpenEditDialog = (bool, product) => {
        setOpenEditDialog(bool);
        setAnchorEl(null);
        if (product) {
            setSelectedProduct(product);
            setProductNote(product.note);
        }
    };
    const handleCloseSnackbar = () => setState({...state, openSuccess: false, openError: false});

    const saveProducts = () => {
        handleOpenFormDialog(false);
        setItems([]);
        getWishlistDetails();
    };

    React.useEffect(() => {
        getWishlistDetails();
    }, [props.selectedWishlist?.id]);
    const formatDate = (timestamp) => {
        const date = new Date(parseInt(timestamp) * 1000);
        return date.toLocaleDateString();
    };

    return (
        <div className={classes.root}>
            {props.loading ? (
                <div style={{textAlign: 'center'}}>
                    <Typography variant="h6" style={{paddingBottom: '20px'}}>Loading...</Typography>
                    <CircularProgress/>
                </div>
            ) : (
                <div>
                    {/* BACK BUTTON */}
                    <Grid item xs={2} className="ml-20">
                        <Button className='red template_button pl-15' startIcon={<ArrowBackIosNewIcon color='error'/>}
                                onClick={back}>
                            <div className='gucci_text_bold ml-8'>Back</div>
                        </Button>
                    </Grid>

                    {/* WISHLIST CONTENT */}
                    <div className="gucci_text_bold mt-8 ml-8">
                        <Grid container alignItems="center" justifyContent="center">
                            <Grid item xs={12}>
                                <Paper className={classes.paper}>
                                    <div className="flex">
                                        <div className="flex center_align">
                                            <LocalMallIcon className="wishlist_icon"/>
                                            <Typography className="gucci_text_bold capitalize" variant="h5">
                                                {props.selectedWishlist.name}
                                            </Typography>
                                        </div>

                                        <div className='hotspot_button left_align flex'>
                                            <Button
                                                onClick={() => handleOpenFormDialog(true)}
                                                color="primary"
                                                className='wishlist_option_button'
                                                startIcon={<AddIcon/>}/>
                                            <Button
                                                onClick={downloadPdf}
                                                color="primary"
                                                className='wishlist_option_button'
                                                startIcon={<PictureAsPdfIcon/>}/>
                                        </div>
                                    </div>

                                    {/* PRODUCTS GRID */}
                                    <div className="mt-15 flex wrap">
                                        {products.length === 0 ? "Nessun prodotto presente" :
                                            products.map((w, index) => (
                                                <div className="mt-15 flex template_product_wishlist pl-15" key={index}>
                                                    <div className="self_center">
                                                        <ButtonBase className={classes.image}>
                                                            <ImageZoom
                                                                image={{
                                                                    src: formatImageUrl(w.imageLink),
                                                                    style: {"max-height": '130px'}
                                                                }}
                                                                zoomImage={{src: formatImageUrl(w.imageLink), alt: ''}}
                                                            />
                                                        </ButtonBase>
                                                    </div>

                                                    <div className="wishlist_product_details">
                                                        <div className="gucci_text_bold ml-8">SMC: {w.smc}</div>
                                                        <div
                                                            className="gucci_text ml-8">Added: {formatDate(w.timestamp)}</div>
                                                        <div
                                                            className="gucci_text ml-8 ellipsis-2">Note: {w.note || '-'}</div>
                                                    </div>

                                                    <div className="remove_product_wishlist flex">
                                                        <Button
                                                            ref={inputEl}
                                                            aria-owns={anchorEl ? 'menu-product' : null}
                                                            aria-haspopup="true"
                                                            onClick={(e) => setAnchorEl({[index]: e.currentTarget})}
                                                            color="primary"
                                                            className='complete_button remove_icon'
                                                            startIcon={<MoreVertIcon/>}/>
                                                        <Menu
                                                            anchorEl={anchorEl && anchorEl[index]}
                                                            keepMounted
                                                            open={Boolean(anchorEl && anchorEl[index])}
                                                            onClose={() => setAnchorEl(null)}
                                                            id="menu-product">
                                                            <MenuItem onClick={() => removeProduct(w)}>Remove
                                                                Product</MenuItem>
                                                            <MenuItem onClick={() => handleOpenEditDialog(true, w)}>Add
                                                                Note</MenuItem>
                                                        </Menu>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                </Paper>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            )}

            {/* FORM DIALOG */}
            <Dialog open={openFormDialog} onClose={() => handleOpenFormDialog(false)} fullWidth>
                <DialogTitle>Add new Products to your wishlist
                    <Button style={{position: "absolute", right: "10px"}} onClick={saveProducts}
                            className='red template_button'>Save</Button>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>Type SMC to add product</DialogContentText>
                    <TextField autoFocus label="SMC" fullWidth variant="standard" value={input}
                               onChange={e => setInput(e.target.value)}/>
                    <List style={{maxHeight: 200, overflow: 'auto'}}>
                        {searching ? <CircularProgress/> : null}
                        {items.map(i => <ListItemText key={i.smc} primary={i.smc}/>)}
                    </List>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleOpenFormDialog(false)} className='black template_button'>Cancel</Button>
                    <Button onClick={() => addProduct(input)} className='red template_button'>Add</Button>
                </DialogActions>
            </Dialog>

            {/* EDIT NOTE DIALOG */}
            <Dialog open={openEditDialog} onClose={() => handleOpenEditDialog(false)} fullWidth>
                <DialogTitle>Add note to your product</DialogTitle>
                <DialogContent>
                    <TextField autoFocus label="Type your note here" fullWidth variant="standard" value={productNote}
                               onChange={e => setProductNote(e.target.value)}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleOpenEditDialog(false)} className='black template_button'>Cancel</Button>
                    <Button onClick={editProductNote} className='red template_button'>Add</Button>
                </DialogActions>
            </Dialog>

            {/* SNACKBARS */}
            <Snackbar anchorOrigin={{vertical: 'bottom', horizontal: 'right'}} open={openSuccess}
                      autoHideDuration={3000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="success">{successMessage}</Alert>
            </Snackbar>
            <Snackbar anchorOrigin={{vertical: 'bottom', horizontal: 'right'}} open={openError} autoHideDuration={3000}
                      onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="error">{errorMessage}</Alert>
            </Snackbar>
        </div>
    );
}
